/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Invite_Success_JoinInputs */

const en_community_invite_success_join = /** @type {(inputs: Community_Invite_Success_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Successfully joined the community!`)
};

const id_community_invite_success_join = /** @type {(inputs: Community_Invite_Success_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berhasil bergabung dengan komunitas!`)
};

/** @type {(inputs: Community_Invite_Success_JoinInputs) => LocalizedString} */
const es_community_invite_success_join = en_community_invite_success_join;

/** @type {(inputs: Community_Invite_Success_JoinInputs) => LocalizedString} */
const fr_community_invite_success_join = en_community_invite_success_join;

/** @type {(inputs: Community_Invite_Success_JoinInputs) => LocalizedString} */
const de_community_invite_success_join = en_community_invite_success_join;

/** @type {(inputs: Community_Invite_Success_JoinInputs) => LocalizedString} */
const ja_community_invite_success_join = en_community_invite_success_join;

/** @type {(inputs: Community_Invite_Success_JoinInputs) => LocalizedString} */
const zh_community_invite_success_join = en_community_invite_success_join;

/** @type {(inputs: Community_Invite_Success_JoinInputs) => LocalizedString} */
const ar_community_invite_success_join = en_community_invite_success_join;

/** @type {(inputs: Community_Invite_Success_JoinInputs) => LocalizedString} */
const it_community_invite_success_join = en_community_invite_success_join;

/** @type {(inputs: Community_Invite_Success_JoinInputs) => LocalizedString} */
const ru_community_invite_success_join = en_community_invite_success_join;

/** @type {(inputs: Community_Invite_Success_JoinInputs) => LocalizedString} */
const pt_community_invite_success_join = en_community_invite_success_join;

/** @type {(inputs: Community_Invite_Success_JoinInputs) => LocalizedString} */
const ko_community_invite_success_join = en_community_invite_success_join;

/**
* | output |
* | --- |
* | "Successfully joined the community!" |
*
* @param {Community_Invite_Success_JoinInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const community_invite_success_join = /** @type {((inputs?: Community_Invite_Success_JoinInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Invite_Success_JoinInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_community_invite_success_join(inputs)
	if (locale === "es") return es_community_invite_success_join(inputs)
	if (locale === "fr") return fr_community_invite_success_join(inputs)
	if (locale === "de") return de_community_invite_success_join(inputs)
	if (locale === "ja") return ja_community_invite_success_join(inputs)
	if (locale === "zh") return zh_community_invite_success_join(inputs)
	if (locale === "ar") return ar_community_invite_success_join(inputs)
	if (locale === "id") return id_community_invite_success_join(inputs)
	if (locale === "it") return it_community_invite_success_join(inputs)
	if (locale === "ru") return ru_community_invite_success_join(inputs)
	if (locale === "pt") return pt_community_invite_success_join(inputs)
	return ko_community_invite_success_join(inputs)
});